// extracted by mini-css-extract-plugin
module.exports = {"fileDropZone":"fileDropZone__ZXaL6","supportedFormats":"supportedFormats__WE2Rb"};